/** Where PixelSign's tenants are, so the select doesn't open on Africa/Abidjan. */
const COMMON_TIME_ZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'UTC',
]

/**
 * Time zone choices: the common US zones first, then every zone the browser
 * knows. `current` is always included, even if the browser doesn't list it.
 */
export function timeZoneOptions(current?: string): { common: string[]; other: string[] } {
  const all = typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : []
  const common = new Set(COMMON_TIME_ZONES)
  const other = all.filter((zone) => !common.has(zone))
  if (current && !common.has(current) && !other.includes(current)) other.unshift(current)
  return { common: COMMON_TIME_ZONES, other }
}
